<template>
  <div class="gl-cart-block">
    <div v-if="totalCount > 0">
      <a href="/shop/cart">
        <span class="icon is-link">
             <i class="fa fa-shopping-cart"></i>
             &nbsp;
         </span>
        {{numeral(totalCount).format('0,0')}} на сумму {{numeral(totalPrice).format('0.00 $')}}
      </a>
    </div>
    <div v-else>
      Корзина пуста
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapGetters } from 'vuex'
  import { numeral } from 'glonass/core/global'

  /**
   * Список ценовых предложений с кнопкой добавления в корзину.
   */
  export default {
    name: 'cart-info',

    data () {
      return {
        numeral
      }
    },

    methods: {
      handleRemove (index) {
      },

      getInitialValue () {
        return this.initialCart
      },

      imageUrl (product) {
        return _.get(product, 'media.data.images[0].medium')
      }
    },

    computed: {
      ...mapGetters('shop', [
        'totalCount',
        'totalPrice'
      ])
    }
  }
</script>

<style scoped lang="scss">
  .gl-increment-block {
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// Widget.vue?3cbe868a